module.exports = __webpack_public_path__ + "img/haulage-step-1.42a6dec8.png";